import $ from "jquery";
import CONSTANT from "../../common/js/_constant";

const header = {
    variables: {
        body:"body",
        headerWrapper: ".header",
        hamburgerButton: ".header__hamburger--button",
        hamburgerContent: ".header__hamburger--menu",
        overlayContainer: ".header__overlay",
        notificationPanelTrigger: ".header__notification--trigger",
        notificationPanel: ".header__notification--panel",
        hamburgerCloseIcon: ".header__hamburger--head",
        navbarItemTrigger: ".header__navbar--item",
        navbarItemDropdownPanel: ".header__navbar--dropdown",
        notificationPanelMobile: ".header__notification--mobile",
        notificationHeaderText: ".header__hamburger--head-title",
        topBtn: "#scrollTop",
        stickyHeader: ".header",
        stickyNavbar: ".sticky__banner--wrapper",
        url: window.location.href,
        notificationText: ".header__notification--trigger-text",
        notificationListItems: ".header__notification--item-background",
    },
    methods: {
        cacheSelectors: function () {
            const v = header.variables;
            header.elements = {
                $body:$(v.body),
                $hamburgerCloseIcon: $(v.hamburgerCloseIcon),
                $hamburgerContent: $(v.hamburgerContent),
                $hamburgerButton: $(v.hamburgerButton),
                $notificationPanelTrigger: $(v.notificationPanelTrigger),
                $notificationPanel: $(v.notificationPanel),
                $notificationPanelMobile: $(v.notificationPanelMobile),
                $notificationHeaderText: $(v.notificationHeaderText),
                $overlayContainer: $(v.overlayContainer),
                $navbarItemTriggers: $(v.navbarItemTrigger),
                $headerWrapper: $(v.headerWrapper),
                $stickyNavbar: $(v.stickyNavbar),
            };
        },
        clickOnHamburgerCloseIcon: function () {
            const { $hamburgerCloseIcon, $hamburgerContent } = header.elements;

            $hamburgerCloseIcon.on("click", function () {
                $hamburgerContent.find(".header__notification--mobile").removeClass("active");
                $hamburgerContent.find(".accordion, .header__socials, .header__app").show();
                header.elements.$notificationHeaderText.css("opacity", "0");
                header.methods.toggleHamburger();
            });
        },
        toggleHamburger: function () {
            const { $hamburgerButton, $hamburgerContent } = header.elements;

            $hamburgerContent.toggleClass("active");
            $hamburgerButton.toggleClass("active");
            $hamburgerButton.attr("aria-expanded", $hamburgerContent.hasClass("active"));

            if ($hamburgerContent.hasClass("active")) {
                header.methods.addOverlay();
                header.methods.disableBodyScroll();
                header.methods.focusIntoMenu();
            } else {
                header.methods.removeOverlay();
                header.methods.enableBodyScroll();
                // Return keyboard focus to the menu button if it was inside the
                // menu (the closed menu is visibility:hidden, so focus would be lost)
                const active = document.activeElement;
                if (!active || active === document.body || $hamburgerContent.get(0).contains(active)) {
                    $hamburgerButton.trigger("focus");
                }
            }
        },
        // Opening the menu moves focus to its first control, so keyboard and
        // screen-reader users land in it rather than behind it (WCAG 2.4.3).
        focusIntoMenu: function () {
            const menu = header.elements.$hamburgerContent.get(0);
            if (!menu) {
                return;
            }
            setTimeout(function () {
                const focusable = menu.querySelectorAll(
                    'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, ' +
                    '[tabindex]:not([tabindex="-1"])'
                );
                const first = Array.prototype.find.call(focusable, function (el) {
                    return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
                });
                if (first) {
                    first.focus();
                }
            }, 50);
        },
        // Desktop mega-menu dropdowns open on hover only, and a closed dropdown
        // is now visibility:hidden (out of the Tab order). Keyboard access
        // follows the W3C "disclosure navigation with top-level links" pattern:
        // after each top-level link a toggle button (visually hidden until it
        // has focus, so mouse users see no change) opens/closes its dropdown.
        // Tab then moves item to item instead of through every dropdown link.
        handleNavbarKeyboard: function () {
            const { $navbarItemTriggers } = header.elements;
            function setOpen($item, isOpen) {
                const $dropdown = $item.find(".nav__dropdown");
                if (isOpen) {
                    $(".nav__dropdown").not($dropdown).removeClass("active");
                    $(".header__navbar--toggle")
                        .not($item.find(".header__navbar--toggle"))
                        .attr("aria-expanded", "false");
                    $(".header__overlay, .header__backdrop").removeClass("d-none");
                }
                $dropdown.toggleClass("active", isOpen);
                $item.find(".header__navbar--toggle").attr("aria-expanded", String(isOpen));
                if (!isOpen && !$(".nav__dropdown.active").length) {
                    $(".header__overlay, .header__backdrop").addClass("d-none");
                }
            }
            $navbarItemTriggers.each(function (index) {
                const $item = $(this);
                const $dropdown = $item.find(".nav__dropdown");
                const $link = $item.find(".header__navbar--link").first();
                if (!$dropdown.length || !$link.length || $item.find(".header__navbar--toggle").length) {
                    return;
                }
                const dropdownId = $dropdown.attr("id") || `header-dropdown-${index}`;
                $dropdown.attr("id", dropdownId);
                const label = $link.text().replace(/\s+/g, " ").trim();
                const $toggle = $(
                    '<button type="button" aria-expanded="false" ' +
                        'class="header__navbar--toggle visually-hidden-focusable">' +
                        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>' +
                    "</button>"
                ).attr({ "aria-controls": dropdownId, "aria-label": `${label} menu` });
                $link.after($toggle);

                $toggle.on("click", function () {
                    setOpen($item, !$dropdown.hasClass("active"));
                });
                // Close when keyboard focus leaves this item
                $item.on("focusout", function (e) {
                    if (e.relatedTarget && !this.contains(e.relatedTarget) && $dropdown.hasClass("active")) {
                        setOpen($item, false);
                    }
                });
                $item.on("keydown", function (e) {
                    if (e.key === "Escape" && $dropdown.hasClass("active")) {
                        e.stopPropagation();
                        setOpen($item, false);
                        $toggle.trigger("focus");
                    }
                });
            });
        },
        // Escape closes the open menu.
        handleHamburgerEscape: function () {
            $(document).on("keydown.hamburgerEscape", function (e) {
                if (e.key === "Escape" && header.elements.$hamburgerContent.hasClass("active")) {
                    header.methods.toggleHamburger();
                }
            });
        },
        disableBodyScroll: function () {
            $("body").css("overflow", "hidden");
        },
        enableBodyScroll: function () {
            $("body").css("overflow", "");
        },
        handleNotificationHover: function () {
            const { $notificationPanelTrigger, $notificationPanel } = header.elements;

            const enterHandler = () => {
                header.methods.addOverlay();
                clearTimeout($notificationPanel.data("hideTimeout"));
                $notificationPanel.css("transform", "scaleY(1)");
            };

            const leaveHandler = () => {
                $notificationPanel.data(
                    "hideTimeout",
                    setTimeout(() => {
                        header.methods.removeOverlay();
                        $notificationPanel.css("transform", "scaleY(0)");
                    }, 100)
                );
            };

            $notificationPanelTrigger.on("mouseenter", enterHandler).on("mouseleave", leaveHandler);
            $notificationPanel.on("mouseenter", enterHandler).on("mouseleave", leaveHandler);
            // Keyboard: show the panel while one of its links has focus, so the
            // focused link is visible (WCAG 2.4.7) instead of in a collapsed panel.
            $notificationPanel.on("focusin", enterHandler).on("focusout", function (e) {
                if (!this.contains(e.relatedTarget)) {
                    leaveHandler();
                }
            });
        },
        handleNotificationMobileHover: function () {
            const {
                $notificationPanelMobile,
                $notificationPanelTrigger,
                $hamburgerContent,
                $notificationHeaderText,
            } = header.elements;

            $notificationPanelTrigger.on("click", function () {
                header.methods.toggleHamburger();
                $notificationPanelMobile.addClass("active");
                $notificationHeaderText.css("opacity", "1");
                if ($notificationPanelMobile.hasClass("active")) {
                    $hamburgerContent.find(".accordion, .header__socials, .header__app").hide();
                }
            });
        },
        addOverlay: function () {
            header.elements.$overlayContainer.addClass("header__overlay--active");
        },
        removeOverlay: function () {
            header.elements.$overlayContainer.removeClass("header__overlay--active");
        },
        handleNavbarItemHover: function () {
            const { $navbarItemTriggers } = header.elements;

            $navbarItemTriggers.each(function () {
                const $trigger = $(this);
                const $panel = $trigger.find(header.variables.navbarItemDropdownPanel);
                const columnCount = $panel.data("column-count");
                $panel.css("grid-template-columns", `repeat(${columnCount}, minmax(0, 1fr))`);
                $panel.css("gap", "20px");

                $(".header__links-level-two").css("display", "grid");
                $(".header__links-level-two").css(
                    "grid-template-columns",
                    `repeat(${columnCount}, minmax(0, 1fr))`
                );
            });
            $navbarItemTriggers.on(CONSTANT.eventsListners.MOUSEOVER,function(e){
                e.stopPropagation()
                if ($(e.target).closest('.nav__dropdown').length === 0) {
                    $('.nav__dropdown').removeClass('active');
            
                    $(this).find('.nav__dropdown').addClass('active');
                    
                    $('.header__overlay').removeClass('d-none');
                    $('.header__backdrop').removeClass('d-none');
                }
            });
            $('.header__overlay,.header__backdrop').on(CONSTANT.eventsListners.MOUSEOVER,function(e){
                e.stopPropagation()
                $('.nav__dropdown').removeClass('active');
                $('.header__overlay').addClass('d-none');
                $('.header__backdrop').addClass('d-none');
            });
        },
        loginClickHandler: function () {
           $('.header__login').on('click', function(){
             var obj = header.methods.dataLayerObj("Header","Login");
             createDataLayer('Login_Clicked', obj);
           })
        },
         notificationClickHandler: function () {
                $('.header__notification--trigger').find('.header__notification--trigger-svg').on('click', function(){
                    var obj = header.methods.dataLayerObj("Header", "Notification");
                    createDataLayer('CheckNotifications', obj);
                })
                $('.header__notification--trigger').find('.header__notification--item-content').on('click', function(){ 
                    let $item = $(this).closest(header.variables.notificationListItems);
                    let buttonName = $(this).find('.header__notification--title').text().replace(/\n/g, '').trim();
                    var obj = header.methods.dataLayerObj("Header", buttonName); 
                    createDataLayer('NotificationSelected', obj);

                    header.methods.handleNotificationClick($item);
                });

        },
    handleNotificationClick: function ($item) {
        if (!$item.length) return;

        let currentBg = $item.css('background-color');
        // normalize white
        const isWhite = currentBg === 'rgb(255, 255, 255)' || currentBg === 'white';

        if (!isWhite) {
            // set to white
            $item.css('background-color', 'white');

            // update counter
            let $counter = $(header.variables.notificationText);
            let count = parseInt($counter.text(), 10) || 0;
            if (count > 0) {
                count -= 1;
                $counter.text(count);
            }

            if($counter === 0){
              $counter.addClass('d-none');
            } else {
              $counter.removeClass('d-none');
            }

            // save state in session
            header.methods.saveNotificationState();
        }
    },

    saveNotificationState: function () {
        let $counter = $(header.variables.notificationText);
        let state = {
            items: [],
            counter: $counter.text(),
            hidden: $counter.hasClass("d-none")
        };

        $(header.variables.notificationListItems).each(function () {
            state.items.push($(this).css('background-color'));
        });

        localStorage.setItem("notificationState", JSON.stringify(state));
    },

    restoreNotificationState: function () {
        let saved = localStorage.getItem("notificationState");
        if (!saved) return; // first load, nothing to restore

        try {
            let state = JSON.parse(saved);
            if (state.items) {
                $(header.variables.notificationListItems).each(function (i) {
                    if (state.items[i]) {
                        $(this).css('background-color', state.items[i]);
                    }
                });
            }
            if (state.counter !== undefined) {
                let $counter = $(header.variables.notificationText);
                $counter.text(state.counter);

                if (state.hidden || parseInt(state.counter, 10) === 0) {
                   $counter.addClass("d-none");
                } else {
                   $counter.removeClass("d-none");
                }

            }
        } catch (e) {
            console.warn("Failed to restore notification state", e);
        }
    },
        toggleNotificationTextColor: function(){
            const notificationNumber = $(header.variables.notificationText).data('notification-text');
            const backgroundColor = $(header.variables.notificationText).data('background-color');
            let textColor = $(header.variables.notificationText).data('text-color');
            textColor = textColor ? textColor : "#000";
            $(header.variables.notificationText).css('color', textColor);
            
            if(notificationNumber === true){
                $(header.variables.notificationText).css('background-color', backgroundColor);
            }else{
                $(header.variables.notificationText).css('background-color', 'transparent');
            }
        },
        setNotificationItemsBackground: function () {
            $(header.variables.notificationListItems).each(function () {
                let notificationBgColor = $(this).data('notification-bgcolor');
                if (notificationBgColor) {
                    $(this).css('background-color', notificationBgColor);
                }
            });
        },
        init: function () {
            // rAF-throttled scroll handler: at most one scrollFunction per paint.
            let scrollTicking = false;
            window.addEventListener('scroll', function() {
                if (!scrollTicking) {
                    scrollTicking = true;
                    window.requestAnimationFrame(function () {
                        header.methods.scrollFunction();
                        scrollTicking = false;
                    });
                }
              }, { passive: true });
            $(header.variables.topBtn).on("click", header.methods.topFunction);
            header.methods.cacheSelectors();
            header.methods.toggleNotificationTextColor();
            header.methods.setNotificationItemsBackground();
            header.methods.restoreNotificationState();
            const { $hamburgerButton } = header.elements;
            $hamburgerButton.on("click", header.methods.toggleHamburger);
            header.methods.handleHamburgerEscape();
            const mediaQuery = window.matchMedia("(min-width: 768px)");

            if (mediaQuery.matches) {
                header.methods.handleNavbarItemHover();
                header.methods.handleNavbarKeyboard();
                header.methods.handleNotificationHover();
            } else {
                header.methods.handleNotificationMobileHover();
            }

            header.methods.clickOnHamburgerCloseIcon();
            header.methods.handleStickyHeader();


        },
        hamburgerClickHandler : function () {
              $(".header__hamburger--close").on('click', function(){
                 var obj = header.methods.dataLayerObj("Hamburger Menu","Hamburger Menu");
                 createDataLayer('hamburgerMenuClick', obj);
              })
        },

        ChliLogoClickHandler : function () {
           $(".header__logo--image").on('click', function(){
              var obj = header.methods.dataLayerObj("Header","LogoClick");
              createDataLayer('LogoClick', obj);
           })
        },
        SearchClickHandler : function () {
           $(".header__search").find('.header__search--svg-find').on('click', function(){
              var obj = header.methods.dataLayerObj("Header","Search Click");
              createDataLayer('SearchClicked', obj);
           })
        },

        SocialMediaShareHandler : function () {
            $(".header__socials--link").on('click', function(element){
               let socialMediaIconText = element.currentTarget.getAttribute('icon');
               var obj = header.methods.dataLayerObj("Hamburger Menu",socialMediaIconText);
               createDataLayer('SocialMediaShare', obj);
            })
        },

        ParentMenuClickHandler : function () {
           $(".header__navbar--link").on('click', function() {
              let text = $(this).text().replace(/\n/g, '').trim();
              var obj = header.methods.dataLayerObj("Top Nav L1",text);
              createDataLayer('TopNav_L1',obj);
           })
        },

        ViewAllClickHandler : function () {
            $(".header--container").on("click",".text-blue-400.chli_btn--link",function() {
               let text = $(this).text().replace(/\s+/g, '').trim();
               let subLinksContainer = $(this).closest('.sublinks__naviagator');
               let topNavL1 = subLinksContainer.closest('.header__navbar--item').find('.header__navbar--link').text().replace(/\s+/g, '').trim();
               let topNavL2 = $(this).closest('.sublinks__navigator--content').find(".sublinks__navigator--content--title").text().replace(/\s+/g, '').trim();
               topNavL2 = topNavL2.replace(/\(?opensinanewtab\)?/i, '');
               let str = topNavL1 && topNavL2 ? topNavL1+"_"+topNavL2 : "Top Nav L3";
               var obj = header.methods.dataLayerObj(str,text);
               createDataLayer('TopNav_L2',obj);
               $('.nav__dropdown').removeClass('active');
               $('.header__overlay').addClass('d-none');
               $('.header__backdrop').addClass('d-none');
            })
        },

        SubLevelMenuClickHandler : function () {
           $(".header--container").on('click', ".sublinks__navigator--content--title", function() {
               let text = $(this).text().replace(/\s+/g, '').trim();
               text = text.replace(/\(?opensinanewtab\)?/i, '');
               let subLinksContainer = $(this).closest('.sublinks__naviagator');
               let topNavL1 = subLinksContainer.closest('.header__navbar--item').find('.header__navbar--link').text().replace(/\s+/g, '').trim();
               let str = topNavL1 ? "TopNav_"+topNavL1 : "TopNav_L1";
               var obj = header.methods.dataLayerObj(str,text);
               createDataLayer('TopNav_L2',obj);
           })
        },

        L3NavMenuClickHandler : function () {
            $(".header--container").on('click',".sublinks__navigator--content--description",function() {
                let text = $(this).text().replace(/\s+/g, '').trim();
                let subLinksContainer = $(this).closest('.sublinks__naviagator');
                let topNavL1 = subLinksContainer.closest('.header__navbar--item').find('.header__navbar--link').text().replace(/\s+/g, '').trim();
                let topNavL2 = $(this).closest('.sublinks__navigator--content').find(".sublinks__navigator--content--title").text().replace(/\s+/g, '').trim();
                topNavL2 = topNavL2.replace(/\(?opensinanewtab\)?/i, '');
                let str = topNavL1 && topNavL2 ? topNavL1+"_"+topNavL2 : "Top Nav L3";
                var obj = header.methods.dataLayerObj(str,text);
                createDataLayer('TopNav_L3',obj);
            })
        },

        HamburgerMenuAccordionClickHandler : function() {
            $(".accordion-header").on("click",".header__accordion--button",function() {
              let text = $(this).find("a").text().trim();
               if (!$(this).hasClass('collapsed')) {
                 let obj = header.methods.dataLayerObj("Hamburger Menu",text);
                 createDataLayer('Expand', obj);
               }
            });
        },

        HamburgerMenuButtonClickHandler : function() {
            $(".header__accordion--body").on("click",".header__accordion--link",function() {
               let text = $(this).text().trim();
               let title = $(this).closest(".header__accordion--item").find(".header__accordion--heading .header__accordion--button a").text().trim();
               let str = title ? "Hamburger Menu_"+title : "";
               let obj = header.methods.dataLayerObj(str,text);
               createDataLayer('buttonClick',obj);
            });
        },

        DownloadAppClickHandler : function() {
          $(".header__app").on("click",".header__app--icon",function (e) {
            let text = e.currentTarget.getAttribute("alt");
            let obj = header.methods.dataLayerObj("Download Section_Hamburger Menu",text);
            createDataLayer('buttonClick',obj);
          });
        },

        PopularSearchesButtonClick : function() {
          $(".global__search--popular").on("click",".global__search__popular--item",function() {
            let text = $(this).text().trim();
            let title = $(this).closest(".global__search--popular").find(".global__search__popular--title h2").text().trim();
            let obj = header.methods.dataLayerObj("Header_"+title,null,text);
            createDataLayer('enter_search_popularsearches',obj);
          });
        },

        scrollFunction() {
            const $topBtn = $(header.variables.topBtn);
            const isPastThreshold = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;

            // Only touch the class when the visible state needs to change.
            if (isPastThreshold && $topBtn.hasClass("d-none")) {
                $topBtn.removeClass("d-none");
            } else if (!isPastThreshold && !$topBtn.hasClass("d-none")) {
                $topBtn.addClass("d-none");
            }
        },

        topFunction() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            let obj = header.methods.dataLayerObj("Footer","Back To Top");
            createDataLayer("buttonClick", obj);
        },

        handleStickyHeader() {
                // (removed an unused `$(".header").offset().top` read here: its
                // result was never used, but it forced a full synchronous layout
                // during page load — the largest forced reflow on the homepage)
                const {$body, $headerWrapper, } = header.elements;

                if($headerWrapper.find(header.variables.stickyNavbar).length > 0 && $(window).width() < CONSTANT.breakpoints.md){
                    $body.css({
                        "padding-top":`124px`,
                    })
                }

               
        },
        setSocialPosition:function(){
            const totalHeight = $('.header__hamburger--menu ').height();
            const menuHeight = $('.mobile__menu--wrapper').height();
            const socialHeight = $('.header__accordion--app');
            if(totalHeight > menuHeight){
                socialHeight.css({
                    "margin-top":`${totalHeight - menuHeight}px`,
                })
            }
        },
        jumpingToRightSectionOfPage:function(){

            // Calculate scroll offset accounting for fixed elements and layout collapse
            // Returns { fixedOffset: px covering viewport, collapse: px removed from doc flow }
            function getScrollAdjustments() {
                var fixedOffset = 0;
                var collapse = 0;

                // Header height (without margins)
                var $header = $('.header .header__wrapper .header--container');
                if (!$header.length) $header = $(".headerCLP .main-logo-container");
                if ($header.length) fixedOffset += $header.outerHeight();

                // Browse bar — when it becomes sticky, its height leaves document flow (collapse)
                // and the sticky bar covers the viewport top (fixedOffset)
                var $browseSection = $('.browseArticlesBySection .browse-article');
                var $browseWrap = $('#articleSwiperWrap');
                if ($browseSection.length && $browseWrap.length) {
                    if ($browseSection.hasClass('custom-sticky')) {
                        // Already sticky — collapse already happened, just account for bar height
                        fixedOffset += $browseWrap.outerHeight();
                    } else {
                        // Not sticky yet — bar will go fixed during scroll:
                        // 1. Its full height leaves document flow (targets shift up)
                        collapse = $browseWrap.outerHeight();
                        // 2. Sticky bar covers viewport top (CSS min-height: 60px)
                        fixedOffset += 60;
                    }
                }

                // Visual breathing room
                fixedOffset += 16;

                return { fixedOffset: fixedOffset, collapse: collapse };
            }

             // Track active scroll animation so repeated clicks cancel the previous one
             var activeScrollFrame = null;

             // Cubic ease-in-out — starts and ends slowly, smooth mid-scroll
             function easeInOutCubic(t) {
                 return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
             }

             // Custom rAF smooth scroll — predictable, no browser-engine startup snap
             function customSmoothScroll(targetY, duration) {
                 // Cancel any previous animation in flight
                 if (activeScrollFrame !== null) {
                     window.cancelAnimationFrame(activeScrollFrame);
                     activeScrollFrame = null;
                 }
                 $('html, body').stop();

                 var startY = window.pageYOffset || document.documentElement.scrollTop;
                 var distance = targetY - startY;

                 // Skip animation for tiny distances — feels like a stutter otherwise
                 if (Math.abs(distance) < 2) {
                     window.scrollTo(0, targetY);
                     return;
                 }

                 var startTime = null;
                 function step(timestamp) {
                     if (startTime === null) startTime = timestamp;
                     var elapsed = timestamp - startTime;
                     var progress = Math.min(elapsed / duration, 1);
                     window.scrollTo(0, startY + distance * easeInOutCubic(progress));
                     if (progress < 1) {
                         activeScrollFrame = window.requestAnimationFrame(step);
                     } else {
                         activeScrollFrame = null;
                     }
                 }
                 activeScrollFrame = window.requestAnimationFrame(step);
             }

             // Scroll to target
             // @param {jQuery} $target - target element
             // @param {string} scrollBehavior - 'smooth' for user clicks, 'instant' for page-load correction
             function scrollToTarget($target, scrollBehavior) {
                 var adj = getScrollAdjustments();
                 var scrollTo = $target.offset().top - adj.collapse - adj.fixedOffset;

                 if (scrollBehavior === 'instant') {
                     // Cancel any ongoing animation and jump
                     if (activeScrollFrame !== null) {
                         window.cancelAnimationFrame(activeScrollFrame);
                         activeScrollFrame = null;
                     }
                     $('html, body').stop();
                     window.scrollTo(0, scrollTo);
                 } else {
                     customSmoothScroll(scrollTo, 600);
                 }
             }

             // --- 1. In-page hash links (href="#section") ---
             $('a[href^="#"]:not([href="#"])').on('click', function (e) {
                 var targetId = $(this).attr('href');
                 var $target = $(targetId);

                 if ($target.length) {
                     e.preventDefault();
                     scrollToTarget($target, 'smooth');
                 }
             });

             // --- 2. Full-path links pointing to current page with hash ---
             // Catches header nav links like "/customer-service#grievanceRedressal"
             // when user is already on /customer-service. Without this, the browser
             // does a native scroll (no header offset) and the target lands behind
             // the sticky header.
             $(document).on('click', 'a[href*="#"]:not([href^="#"]):not([href="#"])', function (e) {
                 var href = $(this).attr('href');
                 if (!href) return;

                 var hashIdx = href.indexOf('#');
                 if (hashIdx < 0) return;

                 var linkPath = href.substring(0, hashIdx);
                 var hash = href.substring(hashIdx);

                 // Normalize paths: strip trailing slash and .html for comparison
                 var currentPath = window.location.pathname.replace(/\.html$/, '').replace(/\/$/, '');
                 linkPath = linkPath.replace(/\.html$/, '').replace(/\/$/, '');

                 if (linkPath === currentPath) {
                     var $target = $(hash);
                     if ($target.length) {
                         e.preventDefault();
                         // Update URL hash without triggering native scroll
                         history.pushState(null, null, hash);
                         scrollToTarget($target, 'smooth');
                     }
                 }
             });

             // --- 3. Page load with hash (e.g. navigated from another page) ---
             // Browser already scrolled natively (no offset), so we correct
             // INSTANTLY to avoid visible bounce/shift.
             $(window).on('load', function () {
                 var hash = window.location.hash;
                 if (hash) {
                     var $target = $(hash);
                     if (!$target.length) return;

                     setTimeout(function () {
                         scrollToTarget($target, 'instant');
                     }, 100);
                 }
             });
        },
        dataLayerObj : function(el,e,searchTerm) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e ? e : "",
                'pageSection' : el ? el : "",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? header.variables.url.includes("blog") ? "Blogs" : header.variables.url.substring(header.variables.url.indexOf(".com/"), header.variables.url.lastIndexOf('/')  === ".com") && !header.variables.url.substring(header.variables.url.indexOf(".com/"), header.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
                'PageSubCategory': "",
                'productName' : document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
                'question' : "",
                'searchTerm' : searchTerm ? searchTerm : "",
                'videoTitle' : "",
                'bannerName' : "",
                'bannerType' : "",
                'leadForm' : "",
            }
            return obj;
        }

    },
};
$(document).ready(function () {
  header.methods.loginClickHandler();
  header.methods.notificationClickHandler();
  });

$(document).ready(function () {
header.methods.hamburgerClickHandler();
header.methods.ChliLogoClickHandler();
header.methods.SocialMediaShareHandler();
header.methods.ViewAllClickHandler();
header.methods.ParentMenuClickHandler();
header.methods.SubLevelMenuClickHandler();
header.methods.L3NavMenuClickHandler();
header.methods.HamburgerMenuAccordionClickHandler();
header.methods.HamburgerMenuButtonClickHandler();
header.methods.DownloadAppClickHandler();
header.methods.SearchClickHandler();
header.methods.PopularSearchesButtonClick();
header.methods.setSocialPosition();
header.methods.jumpingToRightSectionOfPage();
});


if ($(header.variables.headerWrapper).length > 0) {
    header.methods.init();
    // "Landed" is now fired centrally by common/js/landed-event.js so it
    // happens on every page (including pages without this header). Removed
    // the previous createDataLayer("Landed", obj) call here to avoid
    // double-pushing on pages that DO have this header.
}
